<template>
  <div>
    <!-- MENSAJE DE CONFIRMACIÓN -->
    <mensajeSistema></mensajeSistema>

    <!-- FILTROS DE NIVEL, PERIODO, GRADO, ÁREA, SECCIÓN -->
    <v-row class="pl-1">
      <v-col cols="12" sm="" class="pt-0">
        <v-select
          label="Nivel"
          v-model="filter.id_nivel"
          @change="EventNivel(filter.id_nivel)"
          :items="listNivel"
          item-value="id"
          item-text="desc_nivel"
        >
        </v-select>
      </v-col>

      <v-col cols="12" sm="" class="pt-0">
        <v-select
          label="Periodo"
          v-model="filter.id_periodo"
          @change="EventPeriodo(filter.id_periodo, filter.id_seccion)"
          :items="listPeriodo"
          item-value="id"
          item-text="nombre_periodo"
        >
        </v-select>
      </v-col>

      <v-col cols="12" sm="" class="pt-0">
        <v-select
          label="Grado"
          v-model="filter.id_grado"
          @change="EventGrado(filter.id_grado)"
          :items="listGrado"
          item-value="id"
          item-text="desc_grado"
        >
        </v-select>
      </v-col>

      <v-col cols="12" sm="" class="pt-0">
        <v-select
          label="Área"
          v-model="filter.id_area"
          @change="EventArea(filter.id_grado)"
          :items="listArea"
          item-value="id"
          item-text="desc_area"
        >
        </v-select>
      </v-col>

      <v-col cols="12" sm="" class="pt-0">
        <v-select
          label="Sección"
          v-model="filter.id_seccion"
          @change="EventSeccion(filter.id_seccion)"
          :items="listSeccion"
          item-value="id"
          item-text="desc_seccion"
        >
        </v-select>
      </v-col>
    </v-row>
    
    <!-- NOMBRE DEL DOCENTE Y BOTÓN EDITAR CONCLUSIÓN DESCRIPTIVA  -->
    <v-row class="pl-1 pb-1">
      <v-col cols="12" sm="12" class="pt-0 pr-4 d-flex justify-space-between">
        <v-chip small class="color_activo">
          Docente: {{ docente.apellido_nombre }}</v-chip
        >
        <v-tooltip bottom color="#1b1b1b">
          <template v-slot:activator="{ on }">
            <v-btn
              v-if="componenteEvento.editar_submodulo"
              v-on="on"
              class="btn_editar px-0 mx-0"
              fab
              x-small
              @click="EditItem(filter)"
              :disabled="inhabilitarButton"
            >
              <v-icon>fa-pencil-alt</v-icon>
            </v-btn>
          </template>
          <span>EDITAR</span>
        </v-tooltip>
      </v-col>
    </v-row>
    
    <!-- TABLA (VERSION MEJORADA) -->
    <ag-grid-vue
      v-if="isDataLoaded"
      style="width: 100%; height: 650px;"
      class="ag-theme-balham estilo-personalizado-vue-grid"
      :columnDefs="columnasDinamicas"
      @cell-clicked="verObservacion"
      :rowData="dataNew">
    </ag-grid-vue>

    <!-- MODAL AÑADIR CONCLUSIÓN DESCRIPTIVA -->
    <v-form ref="formDatos" lazy-validation>
      <v-dialog v-model="dialog" persistent scrollable max-width="600px">
        <v-card>
          <v-card-title class="modal_title py-5 mb-2">
            <v-row class="d-flex justify-space-between py-0">
              Conclusión descriptiva
              <v-btn
                fab
                dark
                x-small
                class="btn_style3"
                @click="dialog = false"
              >
                <v-icon dark>fa-times</v-icon>
              </v-btn>
            </v-row>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" md="12" class="py-0 pt-2">
                <v-autocomplete
                  label="Estudiante"
                  v-model="dataDescriptiva.id_alumno"
                  :rules="[rul.selectReq]"
                  :items="listAlumno"
                  item-value="id"
                  item-text="nombre_apellido"
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="12" md="12" class="py-0">
                <v-autocomplete
                  label="Competencia"
                  v-model="dataDescriptiva.id_competencia"
                  :rules="[rul.selectReq]"
                  :items="listCompetencia"
                  item-value="id_competencia"
                  item-text="descripcion"
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="12" md="12" class="py-0">
                <v-textarea
                  label="Conclusión descriptiva"
                  v-model="dataDescriptiva.observacion"
                  :rules="[rul.required]"
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :style="{ color: '#ffffff' }"
              class="btn_block_style2"
              
              @click="SaveItem"
              >Guardar</v-btn
            >
          </v-card-actions>
          <span v-if="test">
            Data Modal : <code>{{ dataDescriptiva }}</code> <br />
          </span>
        </v-card>
      </v-dialog>
    </v-form>

    <!-- MODAL VISUALIZAR OBSERVACIONES X COMPETENCIA -->
    <v-dialog v-model="modalObservacion" persistent max-width="900px">
      <v-card  >
        <v-card-title class="modal_title py-5 mb-2">
          <v-row class="d-flex justify-space-between py-0">
          Conclusión descriptiva
          <v-spacer></v-spacer>
          <v-btn
                fab
                dark
                x-small
                class="btn_style3"
                @click="modalObservacion = false"
              >
                <v-icon dark>fa-times</v-icon>
          </v-btn>
          </v-row>
        </v-card-title>

        <v-divider></v-divider>

          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" md="12" class="py-0">
                <v-textarea v-model="observacionEstudianteMostrar" :disabled="true" ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import { AgGridVue } from 'ag-grid-vue';

export default {
  components: { AgGridVue },
  data: () => ({
    paramComponente: { id_submodulo: 2, id_modulo: 4 },
    datoLogin: sessionStorage,
    test: false,

    filter: {},
    listPeriodo: [],
    listNivel: [],
    listGrado: [],
    listSeccion: [],
    listArea: [],
    docente: {},
    observacion: "",
    inhabilitarButton: true,
    isDataLoaded: false,

    //Columnas dinamicas del header
    columnasDinamicas: [],
    dataNew: [],
    
    dialog: false,
    modalObservacion: false,
    observacionEstudianteMostrar: "",
    dataDescriptiva: {},
    listAlumno: [],
    listCompetencia: [],

    //validaciones de formulario
    rul: {
      required: (value) => !!value || "Campo Requerido",
      inputReq: (value) => !!value || "Campo Requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      selectReq2: (value) =>
        (value || "").length > 0 || "Debe seleccionar un campo de la lista",

      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",

      email_null: (value) => {
        if (value == "") {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      },
    },
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),

    studentColumn(){
       return [
         { headerName: "Nombres y Apellidos", field: "nombre_apellido", width: 150, pinned: 'left' },
         { headerName: "Número de documento", field: "numdoc_persona", width: 100, pinned: 'left' },
         { headerName: "Conclusión descriptiva",  pinned: 'left', width: 175, minWidth: 20, cellRenderer: this.iconoObservacion }
       ]
     }
  },

  mounted() {
    this.LoadMain();
  },

  created() {
    this.ActualizarParamentro();
  },

  methods: {
    ...mapActions("login", ["parametroComponente"]),

    ActualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    /**
    _________________________
    |  PETICIONES AL BACK  */
    async LoadMain() {
      this.LimpiarForm();
      await this.GetUserDocente(this.datoLogin.id);
      this.GetNivel(this.datoLogin.id_ano_lectivo, this.filter.id_docente);
    },

    async GetUserDocente(id_usuario) {
      try {
        let response = await axios.get(
          `/sistema/integral/getUsuarioPersonal/${id_usuario}`,
        );
        let resp = response.data;
        if (resp.es_profesor == 1) {
          this.filter.id_docente = resp.id_personal;
          this.docente = resp;
        } else {
          this.setEnviarMens({
            tipo: "W",
            mensaje: `El usuario no es un docente`,
            tiempo: 8000,
          });
          this.docente = {};
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async GetPeriodo(id_colegio, id_ano_lectivo, id_nivel) {
      let params = { id_colegio, id_ano_lectivo, id_nivel };
      try {
        let response = await axios.post(`/sistema/integral/getPeriodo/`, {
          filter: params,
        });
        this.listPeriodo = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async GetNivel(id_ano_lectivo, id_docente) {
      let params = {
        id_ano_lectivo,
        id_docente,
        id_colegio: sessionStorage.id_colegio,
      };
      try {
        let response = await axios.post(`/sistema/integral/getNivelDoc/`, {
          filter: params,
        });
        this.listNivel = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async GetGrado(id_colegio, id_docente, id_nivel) {
      let params = { id_colegio, id_docente, id_nivel };
      try {
        let response = await axios.post(`/sistema/integral/getGradoDoc/`, {
          filter: params,
        });
        this.listGrado = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async GetArea(id_colegio, id_docente, id_grado) {
      let params = { id_colegio, id_docente, id_grado };
      try {
        let response = await axios.post(`/sistema/integral/getAreaDoc/`, {
          filter: params,
        });
        this.listArea = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async GetSeccion(id_colegio, id_docente, id_grado) {
      let params = { id_colegio, id_docente, id_grado };
      try {
        let response = await axios.post(`/sistema/integral/getSeccionDoc/`, {
          filter: params,
        });
        this.listSeccion = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async LoadDataReporte(filter) {
      let params = {
        id_colegio: filter.id_colegio,
        id_ano_lectivo: filter.id_ano_lectivo,
        id_periodo: filter.id_periodo,
        id_seccion: filter.id_seccion,
        id_area: filter.id_area,
        id_docente: filter.id_docente,
        id_usuario: filter.id_usuario,
      };
      try {
        let response = await axios.post(
          `/evaluacion/reporte/registroOficial/`,
          { filter: params }
        );

        //HEADER
        this.columnasDinamicas = this.createColumnDef(response.data.Header);

        //DATA
        this.dataNew = response.data.Data;
        this.processStudentData();

      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async EditItem(filter) {
      this.dataDescriptiva.id_periodo = filter.id_periodo;
      this.dataDescriptiva.id_seccion = filter.id_seccion;
      this.dataDescriptiva.observacion = "";
      this.dialog = true;
      try {
        let filtro = {
          id_ano_lectivo: filter.id_ano_lectivo,
          id_curriculo: filter.id_curriculo,
          id_colegio: filter.id_colegio,
          id_nivel: filter.id_nivel,
          id_grado: filter.id_grado,
          id_area: filter.id_area,
        };

        let resp = await axios.post(
          `/administrativo/competencia/cs/all/`,
          filtro
        );
        this.listCompetencia = resp.data[0].competencias;

        if (!this.listCompetencia) {
          this.setEnviarMens({
            tipo: "E",
            mensaje: `No existe Competencia para los parametros seleccionado `,
            tiempo: 6000,
          });
        }

        let params = {
          id_ano_lectivo: filter.id_ano_lectivo,
          id_colegio: filter.id_colegio,
          id_seccion: filter.id_seccion,
        };
        let response = await axios.post(`/sistema/integral/getAlumnoSeccion/`, {
          filter: params,
        });
        this.listAlumno = response.data.result;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async SaveItem() {
      if (this.$refs.formDatos.validate()) {
        try {
          let params = {
            filter: this.dataDescriptiva,
            id_usuario: this.datoLogin.id,
          };
          let res = "";

          res = await axios.post(
            "/evaluacion/reporte/SaveCompetenciaAlumno",
            params
          );

          this.dialog = false;
          this.setEnviarMens({
            tipo: res.data.messageT,
            mensaje: res.data.message,
            tiempo: null,
          });

          this.LoadDataReporte(this.filter);

        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      }
    },

    /*
    _______________________________________
    |  DISPARADORES Y FUNCIONES DE APOYO */
    EventNivel(id_nivel) {
      this.filter.id_grado = "";
      this.filter.id_area = "";
      this.filter.id_seccion = "";
      this.inhabilitarButton = true;
      this.listArea = [];
      this.listSeccion = [];

      this.GetPeriodo(
        this.datoLogin.id_colegio,
        this.datoLogin.id_ano_lectivo,
        id_nivel
      );
      this.GetGrado(
        this.datoLogin.id_colegio,
        this.filter.id_docente,
        id_nivel
      );
    },

    EventPeriodo(id_periodo, id_seccion) {
      if (id_seccion == "" || id_seccion == undefined) {
        return false;
      }

      this.EventSeccion(id_seccion);
    },

    EventGrado(id_grado) {
      this.filter.id_area = "";
      this.filter.id_seccion = "";
      this.inhabilitarButton = true;
      this.listSeccion = [];
      this.GetArea(this.datoLogin.id_colegio, this.filter.id_docente, id_grado);
    },

    EventArea(id_grado) {
      this.filter.id_seccion = "";
      this.inhabilitarButton = true;
      this.GetSeccion(this.filter.id_colegio, this.filter.id_docente, id_grado);
    },

    EventSeccion(id_seccion) {
      if (id_seccion == "" || id_seccion == undefined) {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe seleccionar una Sección `,
          tiempo: 5000,
        });
        this.inhabilitarButton = true;
        return false;
      }
      this.inhabilitarButton = false;
      this.LoadDataReporte(this.filter);
    },

    //-- PROCESA EL DINAMISMO EN EL HEADER
    createColumnDef(dataHeader){
      let competencias = dataHeader.map(c => {
        return {
          headerName: `Competencia: ${c.competencia}`,
          field: `id_competencia_${c.id_competencia}`,
          headerTooltip: `${c.competencia}`,
          cellStyle: this.getCellStyle
        }
      })

      return this.studentColumn.concat(competencias)
    },

    //-- PROCESA LA CORRECTA ASIGNACIÓN DE LAS NOTAS DE LOS ESTUDIANTES CON LOS NIVELES DE LOGRO POR COMPETENCIA
    processStudentData(){
      this.dataNew = this.dataNew.map(student => {
        let tipo_calificacion = student.tipo_calificacion;
        const newStudent = { ...student };
         student.nivel_de_logro_por_competencia.map(n => {

          //Proceso para renderizar de manera correcta dependiendo si es literal o númerico
          let nota_redondeada_competencia = this.redondearPersonalizado(n.f2);
          let NOTA_COMP_ADABC_123 = this.switchLiteralNumerico(nota_redondeada_competencia, tipo_calificacion)
          newStudent[`id_competencia_${n.f1}`] = NOTA_COMP_ADABC_123;
        });

        return newStudent
      })

      this.isDataLoaded = true;
    },

    redondearPersonalizado(numero) {
      if(numero == null){
        return numero;
      }else {
        const parteDecimal = numero % 1;
        if(parteDecimal <= 0.49){
          return Math.floor(numero)
        }else if(parteDecimal >= 0.5){
          return Math.ceil(numero)
        }
      }
    },

    getCellStyle(params){
      let color = null;

      let nota = params.value;
      switch(nota){
        case 'AD': { 
          color = '#008000'
          break;  
        } 
        case 'A': { 
          color = '#0000ff'
          break; 
        }
        case 'B': { 
          color = '#a52a2a'
          break; 
        }
        case 'C': { 
          color = '#ff0000'
          break;
        }
      }
      return { color: color } ;
    },

    iconoObservacion(e){ 
       let color = `#0ABEC7`;

      const logro = e.data.nivel_de_logro_por_competencia.find(element => element.f4 == null || element.f4 === '');

      if (logro) {
        color = `#B0B0B0`;
      }

      return `<i class="fas fa-comment"
            style="color: ${color}; font-size: 24px; display: flex; align-items: center; justify-content: center;"></i>`
    },

    verObservacion(event){
      //Solo abre el modal cuando se seleccione la celda correcta
      if(event.event.target.classList.contains('fa-comment')){
        this.modalObservacion = true;

        this.observacionEstudianteMostrar = event.data.nivel_de_logro_por_competencia
            .map((comp, index) => {
              return `${index + 1}.- Competencia: ${comp.f3}\n   ${index + 1}.${index + 1} - Observación: ${comp.f4 || 'Sin observación'}\n\n`;
              }).join('');
      }
    },

    switchLiteralNumerico(nota_redondeada, numerica_o_literal){
      let NOTA_ADABC_123;

      if(numerica_o_literal == 'L' || numerica_o_literal == undefined){
          switch(nota_redondeada){
            case 1: {
              NOTA_ADABC_123 = 'C'
              break;
            }
            case 2: {
              NOTA_ADABC_123 = 'B'
              break;
            }
            case 3: {
              NOTA_ADABC_123 = 'A'
              break;
            }
            case 4: {
              NOTA_ADABC_123 = 'AD'
              break;
            }
            default: {
              NOTA_ADABC_123 = '-'
            }
          }
          return NOTA_ADABC_123;
        }else if(numerica_o_literal == 'N'){
          //Aca nose si sea necesario una logica para las notas numericas
        }
    },

    LimpiarForm() {
      this.filter = {
        id_colegio: this.datoLogin.id_colegio,
        id_ano_lectivo: this.datoLogin.id_ano_lectivo,
        id_periodo: "",
        id_nivel: "",
        id_grado: "",
        id_area: "",
        id_seccion: "",
        id_docente: "",
        id_usuario: this.datoLogin.id,
      };
        (this.dataDescriptiva = {
          id_colegio: this.datoLogin.id_colegio,
          id_ano_lectivo: this.datoLogin.id_ano_lectivo,
          id_periodo: "",
          id_seccion: "",
          id_alumno: "",
          id_competencia: "",
          observacion: "",
        });
    },

  },
};
</script>

<style>
.estilo-personalizado-vue-grid{ 
  --ag-foreground-color: rgb(51, 51, 51); 
  --ag-odd-row-background-color: rgb(238, 249, 254);
  --ag-header-foreground-color: rgb(182, 221, 246);
  --ag-header-background-color: #1565c0; 
  
  --ag-border-color: rgb(220, 220, 220);
  --ag-header-border-color: rgb(192, 192, 192);
  --ag-font-family: 'Arial, sans-serif';
  --ag-font-size: 14px;
}
</style>